module.exports = __webpack_public_path__ + "static/img/plu.2ae7a1e0.png";